import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);
    return httpService.get("attachment", { params: params });
  },

  findLatestVbAttachmentPdfByDoc(docId){
    return httpService.get(`attachment/findLatestVbAttachmentPdfByDoc/${docId}`);
  },

  findById( id) {
    return httpService.get("attachment/findById/"+id);
  },

  findAllByObjectIdAndObjectType(example, pageable){
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);
    return httpService.get(`/attachment/findAllByObjectIdAndObjectType/`,{ params: params });
  },

  findAllByVbOutgoingDoc(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    var params = utils.merge(example, pagable);
    return httpService.get("attachment/findAllByVbOutgoingDoc", { params: params });
  },


  findAllByTask(taskId, example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { taskId: taskId },
      utils.merge(example, pageable)
    );
    return httpService.get("attachment/findAllByTask", { params: params });
  },
  findAllByBook(bookDocId, example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { bookDocId: bookDocId },
      utils.merge(example, pageable)
    );
    return httpService.get("attachment/findAllByBook", { params: params });
  },

  delete(id) {
    return httpService.delete("attachment/" + id);
  },

  findAllByComments(commentIds, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ commentIds: commentIds }, pageable);
    return httpService.get("attachment/findAllByComments", { params: params });
  },

  getPageSize(attachmentId, isRelationDoc = false) {
    return this.getAttachmentMetadataRelation(attachmentId, isRelationDoc);
  },

  getAttachmentMetadata(attachmentId, isRelationDoc) {
    return httpService.get("attachment/getAttachmentMetadata", {
      params: { vbAttachmentId: attachmentId }
    });
  },

  getAttachmentMetadataRelation(attachmentId, isRelationDoc) {
    return httpService.get("attachment/getAttachmentMetadataRelation", {
      params: { vbAttachmentId: attachmentId, isRelationDoc: isRelationDoc }
    });
  },

  getPageSizeComment(attachmentMetaId) {
    return httpService.get("attachment/getAttachmentMetadataComment", {
      params: { attachmentMetaId: attachmentMetaId }
    });
  },

  createTemplateFile(form) {
    return httpService.post("attachment/createTemplateFile", form);
  },


  zipExport(form) {
    return httpService.post("attachment/zipExport", form);
  },

  uploadImageDoc(params) {
    return httpService.post("attachment/uploadImageComment2", params);
  },

  uploadFileComment(params) {
    return httpService.post("attachment/uploadFileComment", params);
  },

  uploadFile(params) {
    return httpService.post("attachment/uploadFile", params);
  },

  findReferenceOutgoingAttachment(docId) {
    return httpService.get("attachment/findReferenceOutgoingAttachment", {
      params: { docId: docId }
    });
  },

  getListUserSigned(flowInstanceId) {
    return httpService.get("attachment/signatureInfo", {
      params: { flowInstanceId: flowInstanceId }
    });
  },

  getSignatures(flowInstanceId) {
    return httpService.get("attachment/signatureWithoutSign", {
      params: { flowInstanceId: flowInstanceId }
    });
  },

  getListUserSignedViaDocId(docId) {
    return httpService.get("attachment/signatureInfoViaDocId", {
      params: { docId: docId }
    });
  },

  getStampInfo(flowInstanceId) {
    return httpService.get("attachment/stampInfo", {
      params: { flowInstanceId: flowInstanceId }
    });
  },

  getListStampViaDocId(docId) {
    return httpService.get("attachment/stampInfoViaDocId", {
      params: { docId: docId }
    });
  },

  uploadSignedPdfForwardLD(base64, vbAttachmentId) {
    return httpService.post("vbAttachment/uploadSignedPdfForwardLD", {
      base64: base64,
      vbAttachmentId: vbAttachmentId
    });
  },

  findTrangKySo(outgoingDocId) {
    return httpService.get("attachment/findTrangKySo/" + outgoingDocId);
  },

  uploadSignedPdf(docId, objectType, base64) {
    return httpService.post("vbAttachment/uploadSignedPdf", {
      docId: docId,
      objectType: objectType,
      base64: base64
    });
  },

  cloneFromTask(taskId) {
    return httpService.post("vbAttachment/cloneFromTask", null, {
      params: { taskId: taskId }
    });
  },

  findAllByHcCalendar(hcCaseMasterId) {
    return httpService.get("vbAttachment/findAllByHcCalendar", {
      params: { hcCaseMasterId: hcCaseMasterId }
    });
  },

  deleteHcCalendarFile(id, hcCaseCalendarId) {
    return httpService.delete(`vbAttachment/${id}/deleteHcCalendarFile`, {
      params: { hcCaseCalendarId: hcCaseCalendarId }
    });
  },

  findAllByHcCaseFlightId(hcCaseFlightId, type) {
    let params = { hcCaseFlightId: hcCaseFlightId, type: type };
    return httpService.get("vbAttachment/findAllByHcCaseFlightId", {
      params: params
    });
  },

  findAllByHcCaseMasterId(hcCaseMasterId, type) {
    let params = { hcCaseMasterId: hcCaseMasterId, type: type };
    return httpService.get("vbAttachment/findAllByHcCaseMasterId", {
      params: params
    });
  },

  insertTemporaryForBanHanhVT(docId) {
    return httpService.post("vbAttachment/insertTemporaryForBanHanhVT", null, {
      params: { docId }
    });
  },

  findByObjectIdAndObjectType(objectId, objectType) {
    return httpService.get("vbAttachment/findByObjectIdAndObjectType",
      {params: {objectId: objectId, objectType: objectType}})
  },

  getListUserSignedTest(listPeople) {
    return httpService.post("attachment/signatureInfoTest", listPeople);
  },

  convertWordToPdf(params) {
    return httpService.post("attachment/convertWordToPdf", params);
  },
  filterAttachments(params) {
    return httpService.get("attachment/filter" , {
      params: params
    });
  },
  getObjectTypeFinalByObjectId(objectId) {
    let params = { objectId: objectId };
    return httpService.get("attachment/getObjectTypeFinalByObjectId" , {
      params: params
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/attachmentService.js